import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import {
  Card,
  Image,
  Tooltip,
  Modal,
  Badge,
  Alert,
  Spin,
  Button,
  Select,
} from "antd";

import {
  FileSearchOutlined,
  RightCircleOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";

import Slider from "react-slick";
import homeCss from "css/home.css";
import iconFont from "css/icofont.min.css";
import remixicon from "css/remixicon.css";
import boxicons from "css/boxicons/boxicons.min.css";

import video1 from "../video/safemars-video.mp4";
import video2 from "../video/safemars-video-2.mp4";

import image1 from "../img/babyswap.svg";
import image2 from "../img/gate-io.svg";
import image3 from "../img/latoken.svg";
import image4 from "../img/whitebit.svg";
import image5 from "../img/pancake.svg";
import image6 from "../img/coinsbit.svg";
import image7 from "../img/transp.gif";

import brian from "../img/team/brian.jpeg";
import eduard from "../img/team/eduard.jpeg";
import ken from "../img/team/ken.jpeg";
import martian from "../img/team/martian.jpg";
import safemarsteam from "../img/team/safemarsteam.png";
import zac from "../img/team/zac.png";

function MainHome() {
  const fallbackImg =
    "data:image/png;base64,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";

  const styles = {
    NFTs: {
      display: "flex",
      flexWrap: "wrap",
      WebkitBoxPack: "start",
      justifyContent: "flex-start",
      margin: "0 auto",
      maxWidth: "1000px",
      gap: "10px",
    },
    banner: {
      display: "flex",
      justifyContent: "space-evenly",
      alignItems: "center",
      margin: "0 auto",
      width: "600px",
      //borderRadius: "10px",
      height: "150px",
      marginBottom: "40px",
      paddingBottom: "20px",
      borderBottom: "solid 1px #e3e3e3",
    },
    logo: {
      height: "115px",
      width: "115px",
      borderRadius: "50%",
      // positon: "relative",
      // marginTop: "-80px",
      border: "solid 4px white",
    },
    text: {
      color: "#041836",
      fontSize: "27px",
      fontWeight: "bold",
    },
    paraVersion: {
      fontSize: "1.09rem",
    },
  };

  var settings = {
    slidesToShow: 5,
    slidesToScroll: 1,

    infinite: true,
    autoplay: true,
    arrows: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  };

  var settings1 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div style={styles}>
      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Jost:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
        rel="stylesheet"
      />
      <section id="hero" className="d-flex align-items-center">
        <div className="container" style={{ marginTop: "50px" }}>
          <div className="row">
            <div
              className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1 aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h1>DOWNLOAD ALPHA V1.2</h1>
              <h2 className="safemars_normal_font">
                SafeMarsGame Alpha Join our rocketship to Mars!
              </h2>
              <div className="d-lg-flex center-mobile">
                <a
                  target="_blank"
                  href="https://t.me/safemars"
                  className="btn-get-started scrollto"
                >
                  JOIN TELEGRAM
                </a>
                <a
                  target="_blank"
                  href="https://safemarscrypto.com/game-download/safemarsgame_v3.zip"
                  className="btn-get-started ml-3"
                >
                  DOWNLOAD NOW
                </a>
              </div>
            </div>
            <div
              className="col-lg-6 order-1 order-lg-2 hero-img aos-init aos-animate"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="iframe-container">
                <video autoPlay muted="" loop="" id="myVideo">
                  <source src={video1} type="video/mp4" />
                </video>
              </div>
              <a
                href="https://v1exchange.pancakeswap.finance/#/swap?outputCurrency=0x3ad9594151886ce8538c1ff615efa2385a8c3a88"
                className="token-add btn-get-started scrollto"
                id="item-to-copy"
              >
                Token Address: 0x3aD9594151886Ce8538C1ff615EFa2385a8C3A88
              </a>
            </div>
          </div>

          <Slider
            id="carousel-exchanges"
            {...settings}
            className="carousel-exchanges logo-container col-lg-12 flex-column justify-content-center align-items-center autoplay container"
          >
            <a
              href="https://www.certik.org/projects/safemars"
              target="_blank"
              className="news-element"
            >
              <img src="https://www.certik.org/certik-logotype-h-w.svg" />
            </a>
            <a
              href="https://exchange.babyswap.finance/#/swap?outputCurrency=0x3ad9594151886ce8538c1ff615efa2385a8c3a88"
              target="_blank"
              className="news-element"
            >
              <img src={image1} />
            </a>
            <a
              href="https://www.mexc.com/exchange/SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src="https://www.mexc.com/images/full-logo-normal-mexc.svg?v=10001" />
            </a>
            <a
              href="https://www.ztb.im/exchange?coin=SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src="data:image/jpeg;base64,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" />
            </a>
            <a
              href="https://www.digifinex.tv/en-ww/trade/USDT/SAFEMARS"
              target="_blank"
              className="news-element"
            >
              <img src="data:image/svg+xml,%3Csvg id='_-s-组_5' data-name='-s-组 5' xmlns='http://www.w3.org/2000/svg' width='167' height='32' viewBox='0 0 167 32'%3E %3Cdefs%3E %3Cstyle%3E .cls-1 %7B fill: %2300d0c4; %7D .cls-1, .cls-2 %7B fill-rule: evenodd; %7D .cls-2 %7B fill: %23fff; %7D %3C/style%3E %3C/defs%3E %3Cpath id='形状_1_拷贝_4' data-name='形状 1 拷贝 4' className='cls-1' d='M81.591,25.765L84.664,8.338h3.112L84.7,25.765H81.591Zm24.88-17.427-0.548,3.112H93.2a2,2,0,0,0-1.874,1.593l-0.285,1.619h11.2L101.7,17.773H90.468l-1.409,7.992H85.973l2.243-12.722a5.846,5.846,0,0,1,5.51-4.705h12.746Zm-1.852,17.427,3.072-17.427H110.8L107.73,25.765h-3.111Zm24.85-17.4L126.4,25.789l-2.691-2.39-9.679-8.638-1.945,11.028H108.97l3.064-17.377,2.691,2.39,9.679,8.639,1.958-11.1ZM133,13.043l-0.285,1.619h11.2l-0.549,3.111h-11.2l-0.579,3.286a1.308,1.308,0,0,0,1.312,1.593H145.62l-0.548,3.112H132.351a3.833,3.833,0,0,1-3.851-4.706l1.413-8.016a5.847,5.847,0,0,1,5.51-4.705h12.722L147.6,11.45H134.875A2,2,0,0,0,133,13.043Zm33.238-4.68L157.951,17.1l5.19,8.688h-3.934l-3.67-6.149L149.7,25.789h-3.934l8.229-8.688-5.206-8.738h3.934l3.686,6.2,5.873-6.2h3.909'/%3E %3Cpath id='形状_1_拷贝_3' data-name='形状 1 拷贝 3' className='cls-2' d='M51.65,8.363a7.1,7.1,0,0,1,7.181,8.688,10.468,10.468,0,0,1-3.058,5.626c-0.18.174-.385,0.348-0.59,0.522a10.2,10.2,0,0,1-6.576,2.565H39.893L42.966,8.338ZM43.524,22.678h5.6a6.985,6.985,0,0,0,6.589-5.6,4.577,4.577,0,0,0-4.614-5.6H45.5Zm15.04,3.087L61.637,8.338h3.112L61.676,25.765H58.564Zm9-8.713a4.577,4.577,0,0,0,4.614,5.6h5.6l0.588-3.336h-5.6L73.319,16.2h8.713l-1.686,9.56H71.634a7.117,7.117,0,0,1-7.177-8.713,10.859,10.859,0,0,1,10.25-8.713h8.713L82.871,11.45H74.158A6.984,6.984,0,0,0,67.569,17.051Z'/%3E %3Cg id='组_233' data-name='组 233'%3E %3Cpath id='形状_1_拷贝_2' data-name='形状 1 拷贝 2' className='cls-2' d='M34.382,12.57a24.058,24.058,0,0,1-.426,4.167q-2.765,14.376-16.5,14.376H11.649l0.016-.069,1.4-6.608h4q7.443,0,9.016-8.464c0.074-.361.135-0.725,0.182-1.094l7.96-4.594A16.618,16.618,0,0,1,34.382,12.57ZM31.467,4.255L24.329,8.376a7.264,7.264,0,0,0-4.069-.995H8.742l0.035-.166,1.362-6.384H22.09a16.585,16.585,0,0,1,4.528.573,10.61,10.61,0,0,1,4.533,2.53C31.259,4.041,31.363,4.146,31.467,4.255Z'/%3E %3Cpath id='形状_1_拷贝' data-name='形状 1 拷贝' className='cls-1' d='M20.085,13.065l-1.058,6.6H14.083L11.665,31.045l-0.016.069H0.766L4.852,25.6,7.533,13.065H20.085Z'/%3E %3C/g%3E %3C/svg%3E" />
            </a>
            <a
              href="https://www.gate.io/en/trade/SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src={image2} />
            </a>
            <a
              href="https://latoken.com/exchange/SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src={image3} />
            </a>
            <a
              href="https://hoo.com/innovation/safemars-usdt"
              target="_blank"
              className="news-element"
            >
              <img src="https://static.hooimage.top/media/logos/7e42bb13-1ac5-41bd-b1cc-a03779dc208c.png" />
            </a>
            <a
              href="https://whitebit.com/trade/SMARS_DECL"
              target="_blank"
              className="news-element"
            >
              <img src={image4} />
            </a>
            <a
              href="https://www.bitmart.com/trade/en?symbol=SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src="https://www.bitmart.com/_nuxt/img/logo4w.3b9416b.svg" />
            </a>
            <a
              href="https://v1exchange.pancakeswap.finance/#/swap?outputCurrency=0x3ad9594151886ce8538c1ff615efa2385a8c3a88"
              target="_blank"
              className="news-element"
            >
              <img src={image5} />
            </a>
            <a
              href="https://www.bkex.com/trade/SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src="data:image/png;base64,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" />
            </a>
            <a
              href="https://www.swft.pro/#/"
              target="_blank"
              className="news-element"
            >
              <img src="https://global-uploads.webflow.com/6114973d12c8d738a8fc2487/6160231caee9083680b8bf96_SWFT.svg" />
            </a>
            <a
              href="https://www.bitforex.com/en/spot/safemars_usdt"
              target="_blank"
              className="news-element"
            >
              <img
                src="data:image/svg+xml;base64,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"
                alt="dark"
              />
            </a>
            <a
              href="https://p2pb2b.io/trade/SMARS_USDT/"
              target="_blank"
              className="news-element"
            >
              <img src="https://p2pb2b.io/static/img/logo.svg" />
            </a>
            <a
              href="https://coinsbit.io/trade/SAFEMARS_USDT"
              target="_blank"
              className="news-element"
            >
              <img src={image6} />
            </a>

            <a
              href="https://www.coingecko.com/en/coins/safemars"
              target="_blank"
              className="news-element"
            >
              <img src="https://static.coingecko.com/s/coingecko-logo-white-ce46ba761a521c473f242dd365117820ef82bc370e9d239615cc19eda4a4982d.png" />
            </a>
            <a
              href="https://coinmarketcap.com/currencies/safemars/"
              target="_blank"
              className="news-element"
            >
              <img src="https://s2.coinmarketcap.com/static/cloud/img/coinmarketcap_white_1.svg?_=65f30fb" />
            </a>
          </Slider>
        </div>
      </section>

      <main id="main">
        <section id="cliens" className="cliens section-bg chart ">
          <div className="records">
            <div className="part">
              <a
                target="_blank"
                href="https://dex.guru/token/0x3ad9594151886ce8538c1ff615efa2385a8c3a88-bsc"
              >
                <button>Live Chart</button>
              </a>
            </div>
            <div className="part">
              <h3 className="holders"></h3>
              <p>Current Holders</p>
            </div>
            <div className="part">
              <h3 className="price"></h3>
              <p>Price</p>
            </div>
            <div className="part">
              <h3 className="liquidity"></h3>
              <p>Total Liquidity</p>
            </div>
            <div className="part">
              <h3 className="marketcap"></h3>
              <p>Market Cap</p>
            </div>
            <div className="part">
              <h3 className="burned"></h3>
              <p>SafeMars Burned</p>
            </div>
          </div>
        </section>

        <section id="game-alpha" className="latest-news">
          <div className="section-title">
            <h2>DOWNLOAD V1.2 OF THE SAFEMARS GAME</h2>
          </div>

          <div className="container ">
            <div className="row mb-5">
              <video
                className="video-2"
                autoPlay
                muted=""
                loop=""
                id="myVideo2"
              >
                <source src={video1} type="video/mp4" />
              </video>
            </div>
            <div className="row">
              <p className="text-center " style={styles.paraVersion}>
                We are very happy to release version 1.2 Alpha of the
                long-awaited game. The new version of the game includes high
                score system which users will be able to compete in the very
                near future to win SafeMars Tokens! The game is available to
                download on windows only for the time being so please bare with
                us whilst we release the mac os version and the mobile version
                as it will be available very soon! We ask all those who do
                download the game to give some feedback and take into account
                the following:
              </p>
              <div className="row    d-block  ">
                <ul className="test-dots">
                  <li className="dots icofont-tick-mark show">
                    <p>
                      {" "}
                      This is version 1.1 there will be bugs please report them
                      to one of the admins.{" "}
                    </p>
                  </li>
                  <li className="dots icofont-tick-mark show">
                    <p>
                      {" "}
                      We want to shape this game to something the community
                      loves, feedback is important.{" "}
                    </p>
                  </li>
                  <li className="dots icofont-tick-mark show">
                    <p> The Play2Earn part of the game is not out yet. </p>
                  </li>
                  <li className="dots icofont-tick-mark show">
                    <p> The NFT part of the game is not out yet currently. </p>
                  </li>
                  <li className="dots icofont-tick-mark show">
                    <p>
                      {" "}
                      The score board system for Play2Earn will be available
                      next path.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section-title">
              <h2>Version 1.1 Updates</h2>
            </div>
            <div className="row    d-block  ">
              <ul className="test-dots">
                <li className="dots icofont-tick-mark show">
                  <p> Removed running ability from Player </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Introduced shotgun, pistol, Rocket launcher items </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Pickup ability added for new weapons </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Bug Fixes </p>
                </li>
              </ul>
            </div>
            <div className="section-title">
              <h2>Version 1.2 Updates</h2>
            </div>
            <div className="row    d-block  ">
              <ul className="test-dots">
                <li className="dots icofont-tick-mark show">
                  <p> New High Score System - wallet based. </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> IAdded Blue Stamina Bar for player's running </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Monsters count increased for first round. </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Changed spawning distance with each new wave. </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p>
                    {" "}
                    Enemies will be spawned closer and as count increase with
                    waves they are spawned further apart{" "}
                  </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p>
                    {" "}
                    Weapons picked up will be shown in Equipped section of the
                    Menu{" "}
                  </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Speed of monsters increased by 30% </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> Monsters are shown with Red arrow in Minimap </p>
                </li>
                <li className="dots icofont-tick-mark show">
                  <p> SafeMars Icon added in Build </p>
                </li>
              </ul>
            </div>
            <div className="row d-block mx-auto text-center">
              <a
                target="_blank"
                href="https://safemarscrypto.com/game-download/safemarsgame_v3.zip"
                className="btn-get-started ml-3"
              >
                DOWNLOAD NOW
              </a>
            </div>
          </div>
        </section>

        <section id="latest-news" className="latest-news">
          <div className="container">
            <div className="container" data-aos="fade-up">
              <div className="section-title">
                <h2>Latest News</h2>
              </div>

              <div className="row content">
                <div className="col-lg-6 pt-4 pt-lg-0">
                  <video controls muted="" loop="" id="myVideo">
                    <source src={video2} type="video/mp4" />
                  </video>
                </div>
                <div className="col-lg-6 pt-4 pt-lg-0">
                  <div className="iframe-container">
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube-nocookie.com/embed/9jclqP9HQGU?controls=0"
                      title="YouTube video player"
                      check="Test Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about section-bg">
          <div className="container">
            <div className="section-title">
              <h2>Buy SafeMars</h2>
              <br />
            </div>

            <div className="row content">
              <iframe
                className="col-lg-12"
                id="iframe-swap"
                loading="lazy"
                style={{ height: "570px", width: "100%" }}
                src="https://www.flooz.trade/embedded/0x3ad9594151886ce8538c1ff615efa2385a8c3a88/?refId=gCEb25&backgroundColor=none"
              ></iframe>
            </div>
          </div>
        </section>

        <section id="why-us" className="why-us section-bg">
          <div className="container-fluid" data-aos="fade-up">
            <div className="row">
              <div className="col-lg-7 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">
                <div className="content">
                  <h3>
                    Buy and Hold <strong>SAFEMARS</strong> and you will
                    automatically get more in your wallet. No need to farm,
                    stake or claim.
                  </h3>

                  <p>
                    Each trade also automatically adds liquidity on Pancakeswap
                    leading to an ever-increasing price floor of{" "}
                    <strong>SAFEMARS</strong>. This means that even if every
                    single <strong>SAFEMARS</strong> holder sells, the price
                    will not go to zero.
                  </p>
                </div>

                <div className="accordion-list">
                  <ul>
                    <li>
                      <a
                        data-toggle="collapse"
                        className="collapse"
                        href="#accordion-list-1"
                      >
                        <span>01</span>Community driven project
                        <i className="bx bx-chevron-down icon-show"></i>
                        <i className="bx bx-chevron-up icon-close"></i>
                      </a>

                      <div
                        id="accordion-list-1"
                        className="collapse show"
                        data-parent=".accordion-list"
                      >
                        <p>
                          Though the core development team is always working on{" "}
                          <strong>SAFEMARS</strong>
                          it is the community who can guarantee its success. On
                          Telegram, Facebook, Instagram, TikTok, Reddit and
                          other social media channels, our awesome community is
                          spreading the word about us.
                        </p>
                      </div>
                    </li>

                    <li>
                      <a
                        data-toggle="collapse"
                        href="#accordion-list-2"
                        className="collapsed"
                      >
                        <span>02</span>Rewards holders through static reflection
                        <i className="bx bx-chevron-down icon-show"></i>
                        <i className="bx bx-chevron-up icon-close"></i>
                      </a>

                      <div
                        id="accordion-list-2"
                        className="collapse"
                        data-parent=".accordion-list"
                      >
                        <p>
                          Our tokenomics incentivize holding. We like to say "we
                          pay you to hold". 2% of each transaction goes
                          instantly and gaslessly to the{" "}
                          <strong>SAFEMARS</strong> holders, proportional to
                          their holdings.
                        </p>
                      </div>
                    </li>

                    <li>
                      <a
                        data-toggle="collapse"
                        href="#accordion-list-3"
                        className="collapsed"
                      >
                        <span>03</span>Deflationary Black Hole. Forever!
                        <i className="bx bx-chevron-down icon-show"></i>
                        <i className="bx bx-chevron-up icon-close"></i>
                      </a>

                      <div
                        id="accordion-list-3"
                        className="collapse"
                        data-parent=".accordion-list"
                      >
                        <p>
                          Immediately after launch we burned more than 50% of
                          the total supply of <strong>SAFEMARS</strong>
                          and sent it to a dead wallet. Because the dead wallet
                          is also a holder, it also gets proportional
                          transaction rewards. But since nobody has access to
                          that wallet, those
                          <strong>SAFEMARS</strong> tokens are retired from
                          circulation (effectively burned). The burn happens on
                          every transaction and accelerates as the black hole
                          gets bigger...forever!
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div
                className="col-lg-5 align-items-stretch order-1 order-lg-2 img"
                data-aos-delay="150"
              >
                <div className="gif-wrapper position-relative">
                  <img
                    src={image7}
                    className="img-fluid animated"
                    alt=""
                    style={{ width: "500px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about">
          <div className="container">
            <div className="container" data-aos="fade-up">
              <div className="section-title">
                <h2>About Us</h2>
              </div>
              <div className="row content">
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="ri-check-double-line"></i>Born on the 13th
                      of March 2021!
                    </li>

                    <li>
                      <i className="ri-check-double-line"></i>More than 50% of
                      supply burned
                    </li>

                    <li>
                      <i className="ri-check-double-line"></i>Hodlers are
                      rewarded without paying gas fees
                    </li>

                    <li>
                      <i className="ri-check-double-line"></i>Auto-locking
                      liquidity for an ever-increasing price floor
                    </li>

                    <li>
                      <i className="ri-check-double-line"></i>Deflationary
                      tokenomics protect investors over time
                    </li>

                    <li>
                      <i className="ri-check-double-line"></i>100% safe and
                      unruggable (liquidity locked forever)
                    </li>
                  </ul>
                </div>

                <div className="col-lg-6 pt-4 pt-lg-0">
                  <div className="iframe-container">
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube.com/embed/stp-patIQKU"
                      title="YouTube video player"
                      loading="lazy"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="services section-bg">
          <div className="container" data-aos="fade-up">
            <div className="section-title">
              <h2>Tokenomics</h2>

              <h3>
                SAFEMARS is programmed to reward holders while increasing in
                both liquidity and value. It does this by applying a 4% tax on
                every transaction.
              </h3>
            </div>

            <div className="row">
              <div
                className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div className="icon-box text-center">
                  <div className="icon margin-center">
                    <h4>2</h4>
                    <i className="ri-percent-fill"></i>
                  </div>

                  <p>goes to holders (instantly and gaslessly)</p>
                </div>
              </div>

              <div
                className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="icon-box text-center">
                  <div className="icon margin-center">
                    <h4>1</h4>
                    <i className="ri-percent-fill"></i>
                  </div>

                  <p>auto-locked into liquidity (increases price floor)</p>
                </div>
              </div>

              <div
                className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div className="icon-box text-center">
                  <div className="icon margin-center">
                    <h4>1</h4>
                    <i className="ri-percent-fill"></i>
                  </div>

                  <p>towards prizes and rewards for holders</p>
                </div>
              </div>

              <div className="row mt-5">
                <div className="section-title">
                  <h3>100% safe and unruggable</h3>

                  <p className="mb-4">
                    We value the safety of our investors funds above everything
                    else. That's why we took the steps to ensure{" "}
                    <strong>SAFEMARS</strong> is 100% safe and technically
                    unruggable. The initial liquidity is locked away forever.
                    For the auto-added liquidity by our smart contract, we burn
                    the LP Tokens (think "ticket to liquidity pool") regularly
                    so that it's technically impossible to remove liquidity at
                    any time.
                  </p>

                  <div className="hacken__footer-logo">
                    <p> Certified by </p>

                    <a
                      href="https://www.certik.org/projects/safemars"
                      target="_blank"
                    >
                      <img
                        src="https://www.certik.org/certik-logotype-h-w.svg"
                        style={{ width: "200px" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="roadmap" className="skills">
          <div className="container" data-aos="fade-up">
            <div className="section-title ">
              <h2>Roadmap 2022</h2>
            </div>

            <div className="row mt-2">
              <div className="section-title ">
                <p className="max-w-80 black">
                  SafeMars is officially 1 year old! Thank you to all the
                  community members who have been part of this amazing journey
                  and to all the staff! This is a temporary roadmap until the
                  new website is live with a wider roadmap! coming soon!
                </p>
              </div>
            </div>

            <div className="time-line-wrapper row">
              <Slider
                className="owl-carousel time-line-carousel"
                {...settings1}
              >
                <div className="item completed section-title col">
                  <h2> PHASE 1</h2>

                  <p className="black">#SafeMars Game Alpha V1</p>

                  <i className="icofont-gears"></i>
                </div>

                <div className="item progress-road section-title col">
                  <h2> PHASE 1</h2>

                  <p className="black">#SafeMars Game Alpha V2 - LeaderBoard</p>

                  <i className="icofont-gears"></i>
                </div>

                <div className="item progress-road section-title col">
                  <h2> PHASE 1</h2>

                  <p className="black">New Website! (NFT MARKET LIVE)</p>

                  <i className="icofont-gears"></i>
                </div>

                <div className="item progress-road section-title col">
                  <h2> PHASE 2</h2>

                  <p className="black">Major Advertising Push (Game)</p>

                  <i className="icofont-gears"></i>
                </div>

                <div className="item progress-road section-title col">
                  <h2> PHASE 2</h2>

                  <p className="black">Play To Earn (competitions)</p>

                  <i className="icofont-gears"></i>
                </div>

                <div className="item progress-road section-title col">
                  <h2> PHASE 3</h2>

                  <p className="black">
                    Further Game Developments Announced Soon
                  </p>

                  <i className="icofont-gears"></i>
                </div>
              </Slider>

              <div className="owl-nav">
                <button
                  type="button"
                  role="presentation"
                  className="owl-prev disabled"
                >
                  <i className="bx bxs-chevron-left"></i>
                </button>
                <button type="button" role="presentation" className="owl-next">
                  <i className="bx bxs-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section id="roadmap_old" className="skills">
          <div className="container" data-aos="fade-up">
            <div className="row text-center mx-auto">
              <div className="section-title text-center mx-auto">
                <h2>Roadmap 2021</h2>
              </div>

              <p className="max-w-80 black">
                The SafeMars team is dedicated to delivering results. Since
                launch on the 13th of March the whole community has already come
                a long way. Scroll below for our roadmap of 2021!
              </p>
            </div>

            <Slider
              className="owl-carousel time-line-carousel"
              {...settings1}
              style={{ marginTop: "15px" }}
            >
              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">Safe launch (liquidity locked FOREVER)</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">BURNED 53% of total supply</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">Website redesign</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">Listing on Coingecko, Coinmarketcap</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">Smart contract audit</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">White Paper (multiple languages)</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q1 2021 </h2>

                <p className="black">Listed on WhiteBit</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">Marswap</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">
                  Staking partnership with The Token Kennel
                </p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">NFT mining partnership with Degenr</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">Listed on Gate.io</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">BabySwap partnerships</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">LEGENDS partnerships</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">Marketing push</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">Further partnerships</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">
                  Community votes, events and competitions
                </p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item completed section-title ">
                <h2> Q2 2021 </h2>

                <p className="black">Secret new mission launch</p>

                <i className="icofont-tick-mark"></i>
              </div>

              <div className="item progress-road section-title ">
                <h2> Q3 2021 </h2>

                <p className="black">Staking DApp</p>

                <i className="icofont-gears"></i>
              </div>

              <div className="item progress-road section-title ">
                <h2> Q3 2021 </h2>

                <p className="black">NFT staking & mining</p>

                <i className="icofont-gears"></i>
              </div>

              <div className="item progress-road section-title ">
                <h2> Q3 2021 </h2>

                <p className="black">Listing on top exchanges</p>

                <i className="icofont-gears"></i>
              </div>

              <div className="item progress-road section-title ">
                <h2> Q3 2021 </h2>

                <p className="black">Further ecosystem development</p>

                <i className="icofont-gears"></i>
              </div>
            </Slider>
            <div className="owl-nav">
              <button
                type="button"
                role="presentation"
                className="owl-prev disabled"
              >
                <i className="bx bxs-chevron-left"></i>
              </button>
              <button type="button" role="presentation" className="owl-next">
                <i className="bx bxs-chevron-right"></i>
              </button>
            </div>
          </div>
        </section>

        <section id="cta" className="cta">
          <div className="container" data-aos="zoom-in">
            <div className="row">
              <div className="col-lg-9 text-center text-lg-left">
                <h3>Get involved in the community </h3>

                <p>
                  {" "}
                  SafeMars can only grow and accomplish its mission with YOUR
                  help. Our community numbers in the tens of thousands and
                  everyone can help. Spread the word on social media platforms,
                  answer questions, help people, tell your friends. Or, if you
                  have specialized skills, contact us: smart contract
                  development, web development, multimedia/marketing etc. We
                  also welcome help in moderating our communities, apply any
                  time.
                </p>
              </div>

              <div className="col-lg-3 cta-btn-container text-center">
                <a
                  className="cta-btn align-middle"
                  href="https://t.me/safemars"
                >
                  Get Involved
                </a>
              </div>
            </div>
          </div>
        </section>

        <section id="team" className="team section-bg">
          <div className="container" data-aos="fade-up">
            <div className="section-title">
              <h2>Team</h2>

              <p>
                Our team of developers, marketers and moderators work with a
                shared vision to develop and grow this innovative asset.{" "}
              </p>
            </div>

            <div className="row">
              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <div className="pic">
                    <img src={ken} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Kenneth Churchill</h4>

                    <span>CEO</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/KenSafeEarthMars">
                        <i className="ri-telegram-fill"></i>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/in/kenneth-churchill-safemars-safeearth/"
                      >
                        <i className="ri-linkedin-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <div className="pic">
                    <img src={martian} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>The Martian</h4>

                    <span>Founder / CFO</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/TheCryptoMartian">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4 ">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div className="pic">
                    <img src={safemarsteam} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Jesus</h4>

                    <span>Chief Operating Officer</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://twitter.com/JeesusOg">
                        <i className="ri-twitter-fill"></i>
                      </a>

                      <a target="_blank" href="https://t.me/OgJeesus">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4 ">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div className="pic">
                    <img src={safemarsteam} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>DemonSeated</h4>

                    <span>Chief Marketing Officer</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/DemonSeated">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div className="pic">
                    <img src={eduard} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Eduard</h4>

                    <span>Chief Technology Officer</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/EduardG7">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div className="pic">
                    <img src={safemarsteam} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Rob</h4>

                    <span>Project Manager</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/RobMarsEarth">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div className="pic">
                    <img src={brian} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Brian Dooley</h4>

                    <span>Community Liaison</span>

                    <p></p>

                    <div className="social">
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/in/briananthonydooley/"
                      >
                        <i className="ri-linkedin-fill"></i>
                      </a>

                      <a
                        target="_blank"
                        href="https://twitter.com/BAnthonyDooley"
                      >
                        <i className="ri-twitter-fill"></i>
                      </a>

                      <a target="_blank" href="https://t.me/Banthonydooley">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mt-4">
                <div
                  className="member d-flex align-items-start"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <div className="pic">
                    <img src={safemarsteam} className="img-fluid" alt="" />
                  </div>

                  <div className="member-info">
                    <h4>Boeing F-22 Raptor</h4>

                    <span>Forum mod / Marketing</span>

                    <p></p>

                    <div className="social">
                      <a target="_blank" href="https://t.me/Rocketlite">
                        <i className="ri-telegram-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="faq" className="faq section-bg">
          <div className="container" data-aos="fade-up">
            <div className="section-title">
              <h2>Frequently Asked Questions</h2>

              <p>
                Our team are more than happy to answer any questions you may
                have, most of our discussion takes places in our{" "}
                <a target="_blank" href="https://t.me/safemars">
                  Telegram Channel
                </a>{" "}
                if you want to ask us anything personally. Otherwise you can
                find some frequently asked questions below.
              </p>
            </div>

            <div className="faq-list">
              <ul>
                <li data-aos="fade-up" data-aos-delay="200">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-2"
                    className="collapsed"
                  >
                    How does the transaction tax work?
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-2"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p className="d-inline">
                      SafeMars has a 4% transaction tax.{" "}
                      <a className="scrollto d-inline p-0" href="#services">
                        check our tokenomics
                      </a>
                      section{" "}
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="300">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-3"
                    className="collapsed"
                  >
                    When will you burn more tokens?
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-3"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      We burned more than 50% of the total supply after launch.
                      No more manual burns are planned currently, our Black Hole
                      burns on each transaction. And that burn is continuously
                      accelerating!
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="400">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-4"
                    className="collapsed"
                  >
                    What makes SafeMars different from other coins?{" "}
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-4"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      We think our strong points are our transparency, strong
                      work ethic and commitment to push our boundaries as much
                      and as often as possible. And of course, as a{" "}
                      <strong>SAFEMARS</strong> holder, we basically pay you to
                      hold the token.
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="400">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-5"
                    className="collapsed"
                  >
                    How can I make sure I don't get scammed by clone projects
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-5"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      Always use ONLY our{" "}
                      <a
                        href="https://t.me/safemars"
                        target="_blank"
                        style={{ display: "inline", padding: "0px" }}
                      >
                        official Telegram channel
                      </a>
                      . Our team will NEVER DM you to ask about anything. Be
                      EXTREMELY suspicious about anyone DM-ing you with an offer
                      to help, airdrop or generally asking you personal
                      information such as your wallet seed phrase. NEVER give
                      out such information, block and report those persons
                      immediately.
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="400">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-6"
                    className="collapsed"
                  >
                    When trading on Pancakeswap, do I use V1 or V2?
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-6"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      Use V1, that is the original Pancakeswap liquidity pool.
                      Since our liquidity is locked forever, we cannot move it
                      to V2. It is technically possible to trade in V2, but that
                      pool will contain liquidity added by users so there might
                      be a price difference between pools.
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="400">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-7"
                    className="collapsed"
                  >
                    When trading CEXes (WhiteBit, BitMart, Gate.io) do
                    transaction taxes apply?
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-7"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      No, transaction taxes do not apply on CEXes, they don't
                      support it.
                    </p>
                  </div>
                </li>

                <li data-aos="fade-up" data-aos-delay="400">
                  <i className="bx bx-help-circle icon-help"></i>{" "}
                  <a
                    data-toggle="collapse"
                    href="#faq-list-8"
                    className="collapsed"
                  >
                    When sending SAFEMARS to CEXes (WhiteBit, BitMart, Gate.io)
                    do transaction taxes apply?
                    <i className="bx bx-chevron-down icon-show"></i>
                    <i className="bx bx-chevron-up icon-close"></i>
                  </a>
                  <div
                    id="faq-list-8"
                    className="collapse"
                    data-parent=".faq-list"
                  >
                    <p>
                      Yes, any transfer incurs the 4% tax. This also applies
                      when you send funds to a CEX or any other wallet.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default MainHome;
